import React from "react";
import { LoadingState } from "@shared/common/components/State/LoadingState";
import { ErrorState } from "@shared/common/components/State/ErrorState";
import { usePrepareStore } from "@shared/common/hooks/usePrepareStore";
import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { ConflictSidePanel } from "./ConflictSidePanel";
import { useConflictsQuery } from "./useConflictsQuery";
import { useQuery } from "@tanstack/react-query";

export function ConflictSidePanelWrapper(): React.JSX.Element {
  const { knopClient } = useKnopClient();
  const { instanceId } = useCurrentInstanceId();

  const scenarioQuery = useQuery({
    queryKey: instances.current(instanceId).scenario,
    queryFn: () => knopClient.getScenario(instanceId),
  });
  const conflictsQuery = useConflictsQuery();

  usePrepareStore(scenarioQuery.data, [scenarioQuery, conflictsQuery]);

  if (scenarioQuery.isLoading || conflictsQuery.isLoading) return <LoadingState fullPage={false} />;
  if (scenarioQuery.isError || conflictsQuery.isError) {
    console.log(scenarioQuery.error ?? conflictsQuery.error);
    return <ErrorState />;
  }
  if (!scenarioQuery.data || !conflictsQuery.data) return <ConflictSidePanel conflicts={[]} />;

  return <ConflictSidePanel conflicts={conflictsQuery.data} />;
}
